
import Component from "vue-class-component";
import FormLayout from "@/features/personProfile/components/FormLayout.vue";

import {
    AddSeafaringPracticeRequest,
    factory,
    PracticesClient,
    SeafaringPracticeActions
} from "@/api-client";
import {NavigationGuardNext} from "vue-router/types/router";
import {Prop} from "vue-property-decorator";
import SeafaringPracticeUpsertForm from "@/features/documents/practices/components/SeafaringPracticeUpsertForm.vue";
import {PracticeAddBase} from "@/features/documents/practices/views/PracticeAddBase";

interface Props {
    seafarerId: string;
    actions: SeafaringPracticeActions;
}

@Component({
    components: {
        FormLayout,
        SeafaringPracticeUpsertForm
    },
    beforeRouteEnter(to, from, next: NavigationGuardNext<AddSeafaringPractice>) {
        const props = to.meta!.props as Props;
        props.seafarerId = to.params.seafarerId;
        Promise.all([
            new PracticesClient().availableSeafaringActions()
        ]).then(values => {
            props.actions = values[0];
            next();
        }).catch(e => next(e))
    }
})
export default class AddSeafaringPractice extends PracticeAddBase<AddSeafaringPracticeRequest> implements Props {
    @Prop({required: true})
    seafarerId!: string;

    @Prop({required: true})
    actions!: SeafaringPracticeActions;

    model: AddSeafaringPracticeRequest = factory.create(AddSeafaringPracticeRequest);

    async submitPractice() {
        return await this.submit(this.model);
    }

    getDefaultReturnRouteName(model: AddSeafaringPracticeRequest): string {
        return "seafaring-practice-details";
    }
}
